import { render, staticRenderFns } from "./pushList.vue?vue&type=template&id=32defb9d&scoped=true"
import script from "./pushList.vue?vue&type=script&lang=ts"
export * from "./pushList.vue?vue&type=script&lang=ts"
import style0 from "./pushList.vue?vue&type=style&index=0&id=32defb9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32defb9d",
  null
  
)

export default component.exports